import { render, staticRenderFns } from "./CartPrescription.vue?vue&type=template&id=1e1d9f5c"
import script from "./CartPrescription.vue?vue&type=script&lang=js"
export * from "./CartPrescription.vue?vue&type=script&lang=js"
import style0 from "./CartPrescription.vue?vue&type=style&index=0&id=1e1d9f5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports